<template>
    <v-card class="citation-card px-4 py-2 text-primary"
            variant="outlined">
        <div class="text-lonely text-h6">
            {{text}}
        </div>
        <div class="text-primary text-right text-h6">
            @ {{author}}
        </div>
    </v-card>
</template>

<script>
    export default {
        props: {
            citation: Object,
            showSweetText: Boolean
        },

        computed: {
            text() {
                return this.showSweetText
                    ? this.citation.sweetText
                    : this.citation.text;
            },
            author() {
                return this.showSweetText
                    ? this.citation.author.sweetName
                    : this.citation.author.name;
            }
        }
    };
</script>

<style lang="scss">
    .citation-card {
    }
</style>